import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { slideFadeinUp, slideFadeinRight, zoomFadein, fadein } from './router-animations';

@Component({
  selector: 'layout-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [slideFadeinUp, slideFadeinRight, zoomFadein, fadein],
})
export class LayoutAppComponent {
  routerAnimation: string;

  constructor() {
    this.routerAnimation = 'fadein';
  }

  ngOnInit() {}

  routeAnimation(outlet: RouterOutlet, animation: string) {
    if (animation === this.routerAnimation) {
      return outlet.isActivated && outlet.activatedRoute.routeConfig.path;
    }
  }
  changeOfRoutes() {}
}
